import React, { Suspense, lazy, useCallback, useState } from "react";
import PropTypes from "prop-types";

import { isStandaloneApp } from "../../pwa/browserDisplayMode";

import { expectsLegacyVersionRestore } from "../app/legacyVersionRestoreHint";
import { WelfareBootScreen } from "./WelfareShellBootstrapSkeleton";

const LegacyVersionRestore = lazy(() => import("../app/LegacyVersionRestore"));

/**
 * Entrée de l'interface Classique. Quand ce navigateur annonce une
 * restauration vers la V2 (choix rangé du staff), le squelette V2 occupe
 * l'écran pendant la décision : la V1 n'est jamais peinte puis remplacée.
 * Dans le navigateur, une restauration abandonnée rend la main à la V1.
 * Dans l'application installée, le repli reste en V2.
 */
export default function LegacyEntryGate({ children }) {
  const [restoring, setRestoring] = useState(() => expectsLegacyVersionRestore());
  const release = useCallback(() => setRestoring(false), []);
  // The application adapter redirects to a V2 entry before releasing us.
  // Keep its boot screen until that navigation completes, never paint Classic.
  if (!restoring) return isStandaloneApp() ? <WelfareBootScreen /> : children;
  return (
    <>
      <WelfareBootScreen />
      <Suspense fallback={null}>
        <LegacyVersionRestore onSettled={release} />
      </Suspense>
    </>
  );
}

LegacyEntryGate.propTypes = { children: PropTypes.node.isRequired };
